module.exports = __webpack_public_path__ + "img/9788954607414.6876e490.jpg";